import React, { Fragment, useEffect, useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

import { CartBillItem, CartTotal, CartCouponItem } from '../../cart-items';

import { FOTO_FLAT, SINGLE_PHOTO, PHOTO_DVD } from '../../../../utils/variables';

function CheckoutBillTable(props) {
  const { orderId, bill } = props;
  const [hasBoughtDvd, setHasBoughtDvd] = useState(false);
  const [totalBruttoPriceUnpayed, setTotalBruttoPriceUnpayed] = useState(bill.totalBruttoPriceUnpayed);

  // If the DVD is part of the bought items, the products are NOT only available as
  // download
  useEffect(() => {
    let _hasBoughtDvd = false;
    bill.items.forEach(item => {
      if (item.lineItem.product.type === PHOTO_DVD) {
        _hasBoughtDvd = true;
      }
    });
    setHasBoughtDvd(_hasBoughtDvd);
  }, [bill.items]);

  const onCouponChanged = (cart) => {
    setTotalBruttoPriceUnpayed(cart.order.bill.totalBruttoPriceUnpayed)
    props.onCouponChanged(cart.paymentRequired);
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-16 col-sm-10 col-sm-offset-3">
          <div className="checkout-bill-items-container">
            {bill.items.map(item => (
              <CartBillItem
                billItem={item}
                key={item.id}
                isDownloadOnly={
                  (item.lineItem.product.type === FOTO_FLAT ||
                    item.lineItem.product.type === SINGLE_PHOTO) &&
                  !hasBoughtDvd
                }
              />
            ))}
            <CartCouponItem
              orderId={orderId}
              bill={bill}
              onCouponChanged={onCouponChanged}
            />
            <CartTotal 
              deliveryCharges={bill.charges}
              hasReverseCharge={
                bill.totalNettoPrice === bill.totalBruttoPriceUnpayed &&
                bill.totalBruttoPriceUnpayed > 0
              }
              totalPrice={totalBruttoPriceUnpayed}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

CheckoutBillTable.propTypes = {
  bill: PropTypes.object,
};

export { CheckoutBillTable };

export default createFragmentContainer(CheckoutBillTable, {
  bill: graphql`
    fragment CheckoutBillTable_bill on Bill {
      charges
      items {
        id
        lineItem {
          product {
            type
          }
        }
        ...CartBillItem_billItem
      }
      coupon {
        vat
        brutto
        code
      }
      totalBruttoPrice
      totalBruttoPriceUnpayed
      totalNettoPrice
    }
  `,
});
